import { connect } from 'react-redux';
import { IApplicationState } from '../../../../../../../../types/types';
import { IBoardCardAgingSectionEvents, IBoardCardAgingSectionFields } from '../../components/CardAgingSection/types';
import { getIsUserEssentialPlanOnly } from '../../../../../../../../store/model/authUser/selectors/getIsUserEssentialPlanOnly';
import { CardAgingSection } from '../../components/CardAgingSection/CardAgingSection';
import { onChange } from './events/onChange';
import { IBoardCardAgingSectionHOCProps } from './types';
import { onClose } from './events/onClose';
import { showBoardLimitSnackbarIfNeeded } from '../../../../../effects/showBoardLimitSnackbarIfNeeded';

const mapStateToProps = (
    state: IApplicationState
): IBoardCardAgingSectionFields => {
    return {
        isEssentialFeature: getIsUserEssentialPlanOnly(state)
    };
};

const mapDispatchToProps = (
    dispatch: any,
    { boardId }: IBoardCardAgingSectionHOCProps
): IBoardCardAgingSectionEvents => {
    return {
        onChange: () => dispatch(onChange(boardId)),
        onShowBoardLimitSnackbarIfNeeded: () => dispatch(showBoardLimitSnackbarIfNeeded()),
        onClose: () => dispatch(onClose()),
    }
};

export const CardAgingSectionHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(CardAgingSection);

CardAgingSectionHOC.displayName = 'CardAgingSectionHOC';
